module.exports = __webpack_public_path__ + "media/door_open.94283fed.mp3";